<template>
  <div v-loading="loading" style="height: 686px; overflow-y: auto;">
    <el-page-header
      @back="goBack"
      class="page_header"
      :content="title"
    ></el-page-header>
    <span>账号：{{ username }}</span>
    <template v-if="report_type.data.length > 0">
      <div class="title">{{ title }}</div>
      <el-table border :data="report_type.data" style="width: 100%">
        <el-table-column prop="甲状腺疾病" label="甲状腺功能报告解读次数">
          <template slot-scope="scope">
            <span
              class="link"
              @click="show_anomalies_indicateurs_data('甲状腺疾病')"
              >{{ scope.row.甲状腺疾病 }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="心脏疾病" label="心脏功能报告解读次数">
          <template slot-scope="scope">
            <span
              class="link"
              @click="show_anomalies_indicateurs_data('心脏疾病')"
              >{{ scope.row.心脏疾病 }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="性激素" label="性激素 功能报告解读次数">
          <template slot-scope="scope">
            <span
              class="link"
              @click="show_anomalies_indicateurs_data('性激素')"
              >{{ scope.row.性激素 }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="肿瘤疾病" label="肿瘤功能报告解读次数">
          <template slot-scope="scope">
            <span
              class="link"
              @click="show_anomalies_indicateurs_data('肿瘤疾病')"
              >{{ scope.row.肿瘤疾病 }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="其他" label="其他报告解读次数">
          <template slot-scope="scope">
            <span>{{ scope.row.其他 }}</span>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <template v-if="anomalies_indicateurs.data.length > 0">
      <div class="title">{{ anomalies_indicateurs.name+"报告" }}</div>
      <el-table
        border
        :data="anomalies_indicateurs.data"
        style="width: 100%; max-width: 100%; overflow-x: auto"
      >
        <el-table-column
          v-for="(item, index) in Object.keys(anomalies_indicateurs.data[0])"
          :prop="item"
          :label="item"
          :key="index"
          align="center"
        >
          <template slot-scope="scope">
            <span class="link" @click="show_effect_factor_data(item)">{{
              scope.row[item]
            }}</span>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <template v-if="effect_factor.data.length > 0">
      <div class="title">{{ effect_factor.name }}</div>
      <el-table border :data="effect_factor.data" style="width: 100%">
        <el-table-column prop="生理因素" label="生理因素次数">
          <template slot-scope="scope">
            <span class="link" @click="show_disease_data('生理因素')">{{
              scope.row.生理因素
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="药物因素" label="药物因素次数">
          <template slot-scope="scope">
            <span class="link" @click="show_disease_data('药物因素')">{{
              scope.row.药物因素
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="疾病因素" label="疾病因素次数">
          <template slot-scope="scope">
            <span class="link" @click="show_disease_data('疾病因素')">{{
              scope.row.疾病因素
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="其他因素" label="其他因素次数">
          <template slot-scope="scope">
            <span class="link" @click="show_disease_data('其他因素')">{{
              scope.row.其他因素
            }}</span>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <template v-if="disease.data.length > 0">
      <div class="title">{{ disease.name }}</div>
      <el-table border :data="disease.data" style="width: 100%">
        <el-table-column prop="甲状腺疾病" label="甲状腺疾病次数">
          <template slot-scope="scope">
            <span class="link" @click="show_disease_info_data('甲状腺疾病')">{{
              scope.row.甲状腺疾病
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="心脏疾病" label="心脏疾病次数">
          <template slot-scope="scope">
            <span class="link" @click="show_disease_info_data('心脏疾病')">{{
              scope.row.心脏疾病
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="肿瘤疾病" label="肿瘤疾病次数">
          <template slot-scope="scope">
            <span class="link" @click="show_disease_info_data('肿瘤疾病')">{{
              scope.row.肿瘤疾病
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="性激素" label="性激素疾病次数">
          <template slot-scope="scope">
            <span class="link" @click="show_disease_info_data('性激素')">{{
              scope.row.性激素
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="其他" label="其他疾病次数">
          <template slot-scope="scope">
            <span>{{ scope.row.其他 }}</span>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <template v-if="disease_info.data.length > 0">
      <div class="title">{{ disease_info.name }}</div>
      <el-table border :data="disease_info.data" style="width: 100%">
        <el-table-column prop="name" label="疾病名称" align="center" >
        </el-table-column>
        <el-table-column prop="number" label="次数" align="center" >
        </el-table-column>
      </el-table>
    </template>
  </div>
</template>

<script>
import {
  get_report_type_data,
  get_report_type_data_anomaly,
  get_report_type_data_factor,
  get_report_type_data_disease,
  get_report_type_data_disease_info,
} from "@/api/DataSearch";
import user from "@/store/modules/user";

export default {
  name: "report_type",
  props: {
    title: {
      type: String,
    },
    username: {
      type: String,
    },
    user_id: {
      type: Number,
    },
    name: {
      type: String,
    },
  },
  data() {
    return {
      report_type: {
        name: "",
        data: [],
      },
      anomalies_indicateurs: {
        name: "",
        data: [],
      },
      effect_factor: {
        name: "",
        data: [],
      },
      disease: {
        name: "疾病因素次数",
        data: [],
      },
      disease_info: {
        name: "",
        data: [],
      },
      data: {},
      loading: false,
    };
  },
  created() {
    this.loading = true;
    const params = {
      user_id: this.user_id,
      platform: this.name,
    };
    get_report_type_data(params).then((res) => {
      this.loading = false;
      const { data } = res;
      if (data["code"] === 200) {
        const report_type = {};

        data.data.report_stats.forEach((item) => {
          report_type[item.report_type] = item.count;
        });

        this.$set(this.report_type, "data", [report_type]);
      }
    });
  },
  methods: {
    goBack() {
      this.$router.push("/bec/static");
    },
    show_anomalies_indicateurs_data(report_type) {
      this.report_type.name = report_type;
      this.loading = true;
      const params = {
        user_id: this.user_id,
        platform: this.name,
        report_type: report_type,
      };
      get_report_type_data_anomaly(params).then((res) => {
        this.loading = false;
        const { data } = res;
        if (data["code"] === 200) {
          // console.log(data, "anomalies_indicateurs_data");
          this.anomalies_indicateurs = { name: "", data: [] };
          this.anomalies_indicateurs.name = data.data.report_type;
          const anomalies_indicateurs = {};
          data.data.indicators.forEach((item) => {
            anomalies_indicateurs[item.indicator] = item.count;
          });
          this.anomalies_indicateurs.data = [anomalies_indicateurs];
        }
      });
    },
    show_effect_factor_data(name) {
      this.loading = true;
      const params = {
        user_id: this.user_id,
        platform: this.name,
        report_type: this.report_type.name,
        indicator: name,
      };

      get_report_type_data_factor(params).then((res) => {
        this.loading = false;
        const { data } = res;
        if (data["code"] === 200) {
          // console.log(data, "get_report_type_data_factor");
          this.effect_factor = { name: "", data: [] };
          this.effect_factor.name = data.data.indicator;
          const effect_factor = {};
          data.data.factors.forEach((item) => {
            effect_factor[item.factor_name] = item.count;
          });
          this.$set(this.effect_factor, "data", [effect_factor]);
        }
      });
    },
    show_disease_data(name) {
      this.loading = true;
      const params = {
        user_id: this.user_id,
        platform: this.name,
        report_type: this.report_type.name,
        indicator: this.effect_factor.name,
        factor_type: name,
      };

      // console.log("params", params);
      get_report_type_data_disease(params).then((res) => { 
        this.loading = false;
        const { data } = res;
        if (data["code"] === 200) {
          // console.log(data, "get_report_type_data_disease");
          this.disease = { name: "", data: [] };
          // this.effect_factor.name = data.data.indicator;
          const disease = {};
          data.data.disease_category_stats.forEach((item) => {
            disease[item.disease_category] = item.count;
          });
          this.$set(this.disease, "name", data.data.factor_type);
          this.$set(this.disease, "data", [disease]);
        }
      });
      
      // const report_type_name = this.anomalies_indicateurs.name;
      // this.disease.name = name;
      // const disease = {
      //   甲状腺疾病: 0,
      //   心脏疾病: 0,
      //   性激素: 0,
      //   肿瘤疾病: 0,
      //   其他: 0,
      // };
      // const disease_data =
      //   this.data[report_type_name]["anomalies_indicateurs"][
      //     this.effect_factor.name
      //   ]["influence_factor"]["疾病因素"]["disease_type"];
      // for (const key in disease_data) {
      //   disease[key] = disease_data[key]["number"];
      // }
      // this.$set(this.disease, "data", [disease]);
    },
    show_disease_info_data(name) {
      this.loading = true;
      const params = {
        user_id: this.user_id,
        platform: this.name,
        report_type: this.report_type.name+'报告',
        indicator: this.effect_factor.name,
        factor_type: this.disease.name,
        disease_category: name,
      }

      get_report_type_data_disease_info(params).then((res) => {
        this.loading = false;
        const { data } = res;
        if (data["code"] === 200) {
          // console.log(data, "get_report_type_data_disease_info");
          this.disease_info = { name: "", data: [] };
          // this.disease_info.name = data.data.report_type;
          const disease_info = [];
          this.disease_info.name = data.data.disease_category;
          data.data.disease_stats[0].disease_items.forEach((item) => {
            disease_info.push({
              name: item.disease_name,
              number: item.count,
            });
          });
          this.$set(this.disease_info, "data", disease_info);
        }
      });


      // this.disease_info = { name: name, data: [] };
      // const disease_info = [];
      // try {
      //   const effect_factor = this.effect_factor.name;
      //   const report_type_name = this.anomalies_indicateurs.name;
      //   const disease_data =
      //     this.data[report_type_name]["anomalies_indicateurs"][effect_factor][
      //       "influence_factor"
      //     ]["疾病因素"]["disease_type"][name]["disease"];
      //   for (const key in disease_data) {
      //     disease_info.push({
      //       name: key,
      //       number: disease_data[key],
      //     });
      //   }
      // } catch (e) {
      //   throw e;
      // }
      // this.$set(this.disease_info, "data", disease_info);
    },
  },
  computed: {
    tableData() {
      let data = {};

      for (let i = 0; i < this.anomalies_indicateurs.data.length; i++) {
        data[this.anomalies_indicateurs.data[i].name] =
          this.anomalies_indicateurs.data[i].number;
      }
      return [data];
    },
  },
};
</script>

<style scoped lang="scss">
.page_header {
  margin-bottom: 20px;
}

.table_list {
  display: flex;
  margin: 20px 0;

  & > div:first-child {
    width: 30%;
  }

  & > div:last-child {
    width: 70%;
  }

  .prompt {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.title {
  border-left: 5px solid #983cc9;
  margin: 30px 0;
  padding-left: 20px;
}

.link {
  color: #266fff;
  cursor: pointer;
}
</style>
